import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { useGoalsContext, useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";
import { ContributorCard } from "./ContributorCard";
import { useStyles } from "./styles";

const COLORS_LENGTH = 3;

export const SharedWithSection = () => {
  const { theme } = useTheme();
  const styles = useStyles();
  const { goal } = useGoalsContext();

  const contributors = goal?.partners?.map((p) => ({
    firstName: p?.firstName,
    lastName: p?.lastName,
  }));

  if (!contributors?.length) return null;

  return (
    <>
      <div style={styles.container}>
        <div style={styles.inner}>
          <Body style={styles.title}>{i18n.t(Translations.SharedWithSectionTitle)}</Body>

          {contributors.map((c, index) => {
            const colorIndex = (index % COLORS_LENGTH) + 1;

            // @ts-expect-error
            const color = theme.contact[`item${colorIndex}`];

            return (
              <>
                <Spacing size={SpacingSizes.S} />
                <ContributorCard
                  key={`contributor-card-${index}`}
                  firstName={c.firstName}
                  lastName={c.lastName}
                  color={color}
                />
              </>
            );
          })}
        </div>
      </div>
      <Spacing size={SpacingSizes.M} />
    </>
  );
};
